/**
 * Shared access helpers for the Corporate Security module.
 *
 * Both the navigation (hide) layer (`Sidebar`) and the route (guard) layer
 * (`SecurityModuleRoute`) use these so the two layers can never disagree about
 * who may see Corporate Security surfaces.
 */

/**
 * Roles that grant access to the Corporate Security module (Dashboard, Analytics,
 * Incidents, Executive Protection, Threats, Investigations, Subjects).
 * Effectively every role except a LEGAL_ADMIN-only user.
 */
export const SECURITY_MODULE_ROLES = [
  'SUPER_ADMIN',
  'ADMIN',
  'SECURITY_MANAGER',
  'ANALYST',
  'OPERATOR',
  'VIEWER',
] as const;

/**
 * VIS-132: A user whose ONLY privileged role is LEGAL_ADMIN is restricted to the
 * Legal & Compliance section and must not see Corporate Security surfaces. A user
 * who *also* holds SUPER_ADMIN or ADMIN keeps full visibility.
 */
export function isLegalAdminOnly(roleNames: readonly string[]): boolean {
  return (
    roleNames.includes('LEGAL_ADMIN') &&
    !roleNames.includes('SUPER_ADMIN') &&
    !roleNames.includes('ADMIN')
  );
}
